<template>
  <div>
    <el-row :gutter="15">

      <el-col>
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>排班类别</div>
          <div class="es-op-box">
            <el-input placeholder="请输入类别名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="()=>{this.queryObj.pageNum = 1;loadRosteringTypeList()}">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="del()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="rosteringTypeTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="类别名称">
            </el-table-column>
            <el-table-column prop="startTime"
                             label="开始时间">
            </el-table-column>
            <el-table-column prop="endTime"
                             label="结束时间">
            </el-table-column>
            <el-table-column prop="acrossDay"
                             label="是否跨天">
              <template slot-scope="scope">
                <span v-if="scope.row.acrossDay == 0">否</span>
                <span v-if="scope.row.acrossDay == 1">是</span>
              </template>
            </el-table-column>
            <el-table-column prop="des"
                             label="描述">
            </el-table-column>
            <el-table-column label="操作"
                             width="80"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           type="icon"
                           :key="scope.row.id"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadRosteringTypeList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['rosteringTypeForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑排班类别
      </span>
      <el-form :model="rosteringTypeInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="rosteringTypeForm">
        <el-form-item prop="name"
                      label="类别名称">
          <el-input v-model="rosteringTypeInfo.name"
                    placeholder="请输入类别名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="startTime"
                      label="开始时间">
          <el-time-select v-model="rosteringTypeInfo.startTime"
                          style="width:200px"
                          :picker-options="{start: '00:00',step: '00:15',end: '23:59'}"
                          clearable
                          placeholder="选择开始时间">
          </el-time-select>
        </el-form-item>
        <el-form-item prop="endTime"
                      label="结束时间">
          <el-time-select v-model="rosteringTypeInfo.endTime"
                          style="width:200px"
                          :picker-options="{start: '00:00',step: '00:15',end: '23:59'}"
                          clearable
                          placeholder="选择结束时间">

          </el-time-select>
          <span v-if="rosteringTypeInfo.startTime>=rosteringTypeInfo.endTime">跨天</span>
        </el-form-item>
        <!-- <el-form-item prop="acrossDay"
                      label="是否跨天">
          <el-select v-model="rosteringTypeInfo.acrossDay"
                     style="width:200px"
                     clearable
                     placeholder="请选择是否跨天">
            <el-option label="否"
                       :value="0"></el-option>
            <el-option label="是"
                       :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="des"
                      label="描述">
          <el-input type="textarea"
                    clearable
                    style="width:200px"
                    v-model="rosteringTypeInfo.des"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitRosteringType()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'rosteringtype',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      rosteringTypeInfo: {},//区域信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ],
        // acrossDay: [
        //   { required: true, message: '请选择是否跨天', trigger: 'blur' }
        // ]
      },
      loading: false,
      saving: false
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadRosteringTypeList()
    },
    //从后台查询区域列表
    loadRosteringTypeList () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringType', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true
      this.rosteringTypeInfo = {}
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true
      this.rosteringTypeInfo = JSON.parse(JSON.stringify(row))
    },
    //保存区域信息
    submitRosteringType () {
      this.$refs["rosteringTypeForm"].validate(valid => {
        this.$set(this.rosteringTypeInfo, 'acrossDay', 0)
        if (this.rosteringTypeInfo.startTime >= this.rosteringTypeInfo.endTime) {
          this.$set(this.rosteringTypeInfo, 'acrossDay', 1)
        }
        if (valid) {
          let url = "/buss/rostering/addRosteringType";
          if (this.rosteringTypeInfo.id != null) {
            url = "/buss/rostering/editRosteringType";
          }
          this.saving = true
          this.$ajax.post(url, this.rosteringTypeInfo).then(msg => {
            this.saving = false
            this.loadRosteringTypeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除区域信息
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["rosteringTypeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/rostering/deleteRosteringType', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadRosteringTypeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
